import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "eventSelect",
    "bookingDate",
    "serviceSelect",
    "bookingSummaryService",
    "summaryServiceName",
    "summaryServiceDescription",
    "summaryServicePriceValue",
    "featuresList",
    "featuresArrow"
  ]
  static values = {
    eventsData: Array,
    supplierCategories: Array,
    servicesData: Array,
    selectedServiceId: Number
  }

  connect() {
    if (this.hasEventSelectTarget && this.eventSelectTarget.value) {
      this.updateEventDetails()
    }
  }

  updateEventDetails() {
    const selectedEventId = this.eventSelectTarget.value

    if (!selectedEventId) {
      if (this.hasBookingDateTarget) {
        this.bookingDateTarget.value = ""
      }
      return
    }

    const event = this.eventsDataValue.find(e => e.id === parseInt(selectedEventId))

    if (event && this.hasBookingDateTarget) {
      const dateOnly = event.event_date.split('T')[0]
      this.bookingDateTarget.value = dateOnly
    }
  }

  updateServiceDetails() {
    const selectedServiceId = this.serviceSelectTarget.value

    if (!selectedServiceId) {
      if (this.hasBookingSummaryServiceTarget) {
        this.bookingSummaryServiceTarget.classList.add("hidden")
      }
      return
    }

    const service = this.servicesDataValue.find(s => s.id === parseInt(selectedServiceId))

    if (service) {
      if (this.hasBookingSummaryServiceTarget) {
        this.bookingSummaryServiceTarget.classList.remove("hidden")
      }
      if (this.hasSummaryServiceNameTarget) {
        this.summaryServiceNameTarget.textContent = service.name
      }
      if (this.hasSummaryServiceDescriptionTarget) {
        this.summaryServiceDescriptionTarget.textContent = service.description
      }
      if (this.hasSummaryServicePriceValueTarget) {
        this.summaryServicePriceValueTarget.textContent = service.formatted_price
      }

      // Update features list and collapse it
      if (this.hasFeaturesListTarget) {
        this.featuresListTarget.classList.add("hidden")
        const features = service.feature_list || []
        if (features.length > 0) {
          this.featuresListTarget.innerHTML = `
            <ul class="space-y-1 text-xs text-gray-700">
              ${features.map(f => `
                <li class="flex items-start gap-1.5">
                  <i class="ph ph-check text-teal-600 mt-0.5 shrink-0"></i>
                  <span>${this.escapeHtml(f.trim())}</span>
                </li>
              `).join('')}
            </ul>
          `
        } else {
          this.featuresListTarget.innerHTML = `
            <ul class="space-y-1 text-xs text-gray-700">
              <li class="text-gray-400 italic">No details available</li>
            </ul>
          `
        }
      }
      if (this.hasFeaturesArrowTarget) {
        this.featuresArrowTarget.style.transform = ""
      }
    }
  }

  toggleFeatures() {
    if (!this.hasFeaturesListTarget) return

    const isHidden = this.featuresListTarget.classList.toggle("hidden")
    if (this.hasFeaturesArrowTarget) {
      this.featuresArrowTarget.style.transform = isHidden ? "" : "rotate(180deg)"
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat('en-PH', {
      style: 'currency',
      currency: 'PHP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount)
  }
}
